import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { FC, ReactNode } from "react";

import styles from "./InfoWarningText.module.css";
import Translated from "./infrastructure/Translated";
import { TranslateTextKeyType } from "./infrastructure/useTranslate";

type Props = {
  textkey: TranslateTextKeyType;
  simple?: boolean;
  red?: boolean;
  children?: ReactNode;
  className?: string;
};

const InfoWarningText: FC<Props> = ({
  textkey,
  simple = false,
  red = false,
  children,
  className,
}) => {
  return (
    <div
      className={classNames(
        simple ? styles.simple : styles.infoWarningText,
        className,
      )}
      data-testid="info-warning-text"
    >
      <p style={{ margin: 0 }}>
        <FontAwesomeIcon
          icon={faExclamationCircle}
          className={classNames(red ? styles.iconRed : styles.iconYellow)}
        />{" "}
        <Translated textKey={textkey} />
      </p>
      {children}
    </div>
  );
};

export default InfoWarningText;
